<template>
  <ul class="flex">
    <slot />
  </ul>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsMenu'
})
</script>
